module.exports = __webpack_public_path__ + "media/images/cards/visa-df2eb2e0550be67ad12b3090648483dc.png";